module.exports = "<button class=\"modal__close-button icon-cross icon icon--action icon--round\" v-on:click=\"hide\" v-if=\"showCloseBtn\"></button>\n</div>\n</div>\n</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/modals/partials/footer.html
// module id = /Mwj
// module chunks = 1